import { ButtonLink } from "../components/ui/Button";

/** The landing page's 404, in the app's frame: the page is "off air". */
export function NotFound() {
  return (
    <div className="flex flex-col items-start gap-4 rounded-xl border-2 border-dashed border-ink bg-card p-8">
      <span className="inline-flex items-center gap-2 rounded-md bg-ink px-2.5 py-1 font-mono text-xs font-bold tracking-wider text-white">
        <i aria-hidden="true" className="size-2 rounded-full bg-board-muted" />OFF AIR
      </span>
      <h1 className="text-3xl font-bold">This page is not broadcasting.</h1>
      <p className="text-muted">The link may be old or mistyped. Everything else is still live.</p>
      <ButtonLink to="/streams" variant="primary">go to streams</ButtonLink>
    </div>
  );
}
